"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MessageResolver = void 0;
// eslint-disable-next-line import/prefer-default-export
const MessageResolver = _ref => {
  let {
    statusCode,
    message,
    customMessageResolver,
    defaultMessage,
    customMessage,
    context
  } = _ref;
  if (customMessageResolver) {
    const resolvedMessage = customMessageResolver({
      statusCode,
      message,
      context
    });
    if (resolvedMessage) {
      return resolvedMessage;
    }
  }
  if (statusCode === 418 || message && /locked/.test(message)) {
    return 'Your account has been temporarily locked.  Please try again later.';
  }
  if (statusCode === 404) {
    return 'Unfortunately the document you requested cannot be located. You may try to verify the URL for proper spelling, or you may try one of the destinations below:';
  }
  return customMessage || message || defaultMessage;
};
exports.MessageResolver = MessageResolver;
//# sourceMappingURL=MessageResolver.js.map